var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"help"},[_c('el-tooltip',{attrs:{"effect":"dark","content":"帮助中心","placement":"bottom"}},[_c('el-button',{staticClass:"d2-mr btn-text can-hover",attrs:{"type":"text"}},[_c('span',{staticClass:"iconfont iconnav_bangzhuzhongxin",staticStyle:{"font-size":"16px"},on:{"click":_vm.goHelp}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }